// Shared Esc-to-close behavior for modal/dialog overlays. Every modal in the
// app should call this so Escape consistently closes it, instead of each
// component hand-rolling its own keydown listener.
import { useEffect } from "react";

/** Closes the calling modal when the user presses Escape. Pass `enabled =
 * false` to temporarily suspend (e.g. while a nested confirm dialog is open
 * and should get first crack at the keypress instead). */
export function useEscapeToClose(onClose: () => void, enabled = true): void {
  useEffect(() => {
    if (!enabled) return;
    function onKeyDown(e: KeyboardEvent) {
      if (e.key === "Escape") onClose();
    }
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [onClose, enabled]);
}
